export const getTaskMilestones = (state) => state.milestones
export const getProjectMilestones = (state) => state.allMilestone
